import { useState } from 'react';
import { useIntl } from 'react-intl';

import AuthForm from '@/components/authForm/AuthForm';
import PaymentForm from '@/components/giftCard/PaymentForm';
import ScreenHeading from '@/components/screens/ScreenHeading';
import { useAuthFormModeState, usePurchaseParamsState, useUserState } from '@/hooks/store';
import messages from '@/messages/messages';

import _messages from './messages';
import * as Styled from './styles';

const LifetimeHero = () => {
	const { formatMessage } = useIntl();
	const user = useUserState();
	const authFormMode = useAuthFormModeState();

	const [activeScreen, setActiveScreen] = useState<'account' | 'payment'>(
		user?.token ? 'payment' : 'account',
	);

	const onAuthSuccess = () => {
		setActiveScreen('payment');
	};

	const { giftPrice } = usePurchaseParamsState();

	return (
		<Styled.GiftCardHeroWrapper>
			<Styled.FullscreenBackgroundDesktop
				src="/_n/images/gift-card/background-giftcard.webp"
				objectPosition="center center"
			/>
			<Styled.Grid>
				<Styled.HolidayUpsell>
					<Styled.FullscreenBackgroundMobile
						src="/_n/images/gift-card/background-giftcard-tablet.webp"
						objectPosition="center top"
					/>
					<Styled.GiftCardHeroContent>
						<Styled.GiftCardHeroHeading>{formatMessage(_messages.heading)}</Styled.GiftCardHeroHeading>
						{giftPrice?.price !== giftPrice?.originalPrice && (
							<Styled.GiftCardHeroSubheading>
								<Styled.Check />
								{formatMessage(_messages.bullet1)}
							</Styled.GiftCardHeroSubheading>
						)}
						<Styled.GiftCardHeroSubheading>
							<Styled.Check />
							{formatMessage(_messages.bullet2)}
						</Styled.GiftCardHeroSubheading>
						<Styled.GiftCardHeroSubheading>
							<Styled.Check />
							{formatMessage(_messages.bullet3)}
						</Styled.GiftCardHeroSubheading>
					</Styled.GiftCardHeroContent>
				</Styled.HolidayUpsell>
				<Styled.HolidayFormContainer>
					{activeScreen === 'account' && (
						<Styled.AccountWrapper>
							<ScreenHeading>
								{authFormMode === 'signup'
									? formatMessage(messages.signupTitle)
									: formatMessage(messages.loginTitle)}
							</ScreenHeading>
							<AuthForm onAuthSuccess={onAuthSuccess} />
						</Styled.AccountWrapper>
					)}
					{activeScreen === 'payment' && giftPrice?.price && (
						<PaymentForm
							price={giftPrice?.price}
							originalPrice={giftPrice?.originalPrice}
							offerFreeCount={0}
							giftType="lifetime"
						/>
					)}
				</Styled.HolidayFormContainer>
			</Styled.Grid>
		</Styled.GiftCardHeroWrapper>
	);
};

export default LifetimeHero;
